//  ______                        _               _  _  _
//  |  _  \                      | |             | |(_)| |
//  | | | |  ___    _ __    ___  | |_    ___   __| | _ | |_
//  | | | | / _ \  | '_ \  / _ \ | __|  / _ \ / _` || || __|
//  | |/ / | (_) | | | | || (_) || |_  |  __/| (_| || || |_
//  |___/   \___/  |_| |_| \___/  \__|  \___| \__,_||_| \__|
//
// Generated by skir-typescript-gen
// Home: https://github.com/gepheum/skir-typescript-gen
//
// To install the Skir client library:
//   npm i skir-client

/// <reference types="./meeting_common.d.ts" />

import * as $ from "skir-client";
import * as x_call_utils from "./call_utils.js";
import * as x_meeting_state from "./meeting_state.js";

// -----------------------------------------------------------------------------
// enum MeetingProcessingStatus
// -----------------------------------------------------------------------------

/** Deeply immutable. */
export class MeetingProcessingStatus extends $._EnumBase {}

// -----------------------------------------------------------------------------
// struct MeetingInfo.ResolvedClassification
// -----------------------------------------------------------------------------

/**
 * Deeply immutable. If you need mutability, use `MeetingInfo.ResolvedClassification.Mutable`.
 *
 * @alias MeetingInfo.ResolvedClassification
 */
class MeetingInfo_ResolvedClassification extends $._FrozenBase {}

function initMeetingInfo_ResolvedClassification(target, initializer) {
  target.dimensionValueId = initializer.dimensionValueId ?? 0;
  target.confidenceScore = initializer.confidenceScore ?? 0;
  target.source = initializer.source ?? "";
  target.evidenceQuote = initializer.evidenceQuote ?? null;
  target.evidenceOffsetSeconds = initializer.evidenceOffsetSeconds ?? null;
}

// -----------------------------------------------------------------------------
// struct MeetingInfo
// -----------------------------------------------------------------------------

/** Deeply immutable. If you need mutability, use `MeetingInfo.Mutable`. */
export class MeetingInfo extends $._FrozenBase {}

function initMeetingInfo(target, initializer) {
  target.meetingId = initializer.meetingId ?? "";
  target.userId = initializer.userId ?? "";
  target.joinedAt = initializer.joinedAt ?? $.Timestamp.UNIX_EPOCH;
  target.meetingName = initializer.meetingName ?? "";
  target.participants = $._toFrozenArray(
    initializer.participants || [],
    x_call_utils.Participant.create,
  );
  target.platform = x_meeting_state.MeetingSource.Platform.create(initializer.platform ?? x_meeting_state.MeetingSource.Platform.UNKNOWN);
  target.description = initializer.description ?? "";
  target.simulatedCall = initializer.simulatedCall ?? false;
  target.tags = $._toFrozenArray(
    initializer.tags || []);
    target.spaceIds = $._toFrozenArray(
      initializer.spaceIds || []);
      target.isPrivate = initializer.isPrivate ?? false;
      target.calendarEventId = initializer.calendarEventId ?? null;
      target.crmAccountId = initializer.crmAccountId ?? null;
      target.crmOpportunityId = initializer.crmOpportunityId ?? null;
      target.detectedLanguage = initializer.detectedLanguage ?? null;
      target.processingStatus = MeetingProcessingStatus.create(initializer.processingStatus ?? MeetingProcessingStatus.UNKNOWN);
      target.endedAt = initializer.endedAt ?? null;
      target.isInternal = initializer.isInternal ?? false;
      target.classifications = $._toFrozenArray(
        initializer.classifications || [],
        MeetingInfo_ResolvedClassification.create,
      );
      target.accountId = initializer.accountId ?? BigInt(0);
}

// -----------------------------------------------------------------------------
// Initialize the serializers
// -----------------------------------------------------------------------------

$._initModuleClasses(
  "meeting_common.skir",
  [
    {
      kind: "enum",
      ctor: MeetingProcessingStatus,
      name: "MeetingProcessingStatus",
      variants: [
        {
          name: "UNKNOWN",
          number: 0,
        },
        {
          name: "RECORDING",
          number: 1,
        },
        {
          name: "PROCESSING",
          number: 2,
        },
        {
          name: "COMPLETED",
          number: 3,
        },
      ],
    },
    {
      kind: "struct",
      ctor: MeetingInfo_ResolvedClassification,
      initFn: initMeetingInfo_ResolvedClassification,
      name: "ResolvedClassification",
      parentCtor: MeetingInfo,
      fields: [
        {
          name: "dimension_value_id",
          property: "dimensionValueId",
          number: 0,
          type: {
            kind: "primitive",
            primitive: "int32",
          },
        },
        {
          name: "confidence_score",
          property: "confidenceScore",
          number: 1,
          type: {
            kind: "primitive",
            primitive: "float32",
          },
        },
        {
          name: "source",
          property: "source",
          number: 2,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "evidence_quote",
          property: "evidenceQuote",
          number: 3,
          type: {
            kind: "optional",
            other: {
              kind: "primitive",
              primitive: "string",
            },
          },
        },
        {
          name: "evidence_offset_seconds",
          property: "evidenceOffsetSeconds",
          number: 4,
          type: {
            kind: "optional",
            other: {
              kind: "primitive",
              primitive: "float32",
            },
          },
        },
      ],
    },
    {
      kind: "struct",
      ctor: MeetingInfo,
      initFn: initMeetingInfo,
      name: "MeetingInfo",
      fields: [
        {
          name: "meeting_id",
          property: "meetingId",
          number: 0,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "user_id",
          property: "userId",
          number: 1,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "joined_at",
          property: "joinedAt",
          number: 2,
          type: {
            kind: "primitive",
            primitive: "timestamp",
          },
        },
        {
          name: "meeting_name",
          property: "meetingName",
          number: 3,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "participants",
          property: "participants",
          number: 4,
          type: {
            kind: "array",
            item: {
              kind: "record",
              ctor: x_call_utils.Participant,
            },
          },
          mutableGetter: "mutableParticipants",
        },
        {
          name: "platform",
          property: "platform",
          number: 5,
          type: {
            kind: "record",
            ctor: x_meeting_state.MeetingSource.Platform,
          },
        },
        {
          name: "description",
          property: "description",
          number: 6,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "simulated_call",
          property: "simulatedCall",
          number: 7,
          type: {
            kind: "primitive",
            primitive: "bool",
          },
        },
        {
          name: "tags",
          property: "tags",
          number: 8,
          type: {
            kind: "array",
            item: {
              kind: "primitive",
              primitive: "string",
            },
          },
          mutableGetter: "mutableTags",
        },
        {
          name: "space_ids",
          property: "spaceIds",
          number: 10,
          type: {
            kind: "array",
            item: {
              kind: "primitive",
              primitive: "int32",
            },
          },
          mutableGetter: "mutableSpaceIds",
        },
        {
          name: "is_private",
          property: "isPrivate",
          number: 11,
          type: {
            kind: "primitive",
            primitive: "bool",
          },
        },
        {
          name: "calendar_event_id",
          property: "calendarEventId",
          number: 12,
          type: {
            kind: "optional",
            other: {
              kind: "primitive",
              primitive: "string",
            },
          },
        },
        {
          name: "crm_account_id",
          property: "crmAccountId",
          number: 13,
          type: {
            kind: "optional",
            other: {
              kind: "primitive",
              primitive: "int32",
            },
          },
        },
        {
          name: "crm_opportunity_id",
          property: "crmOpportunityId",
          number: 14,
          type: {
            kind: "optional",
            other: {
              kind: "primitive",
              primitive: "int32",
            },
          },
        },
        {
          name: "detected_language",
          property: "detectedLanguage",
          number: 15,
          type: {
            kind: "optional",
            other: {
              kind: "primitive",
              primitive: "string",
            },
          },
        },
        {
          name: "processing_status",
          property: "processingStatus",
          number: 16,
          type: {
            kind: "record",
            ctor: MeetingProcessingStatus,
          },
        },
        {
          name: "ended_at",
          property: "endedAt",
          number: 17,
          type: {
            kind: "optional",
            other: {
              kind: "primitive",
              primitive: "timestamp",
            },
          },
        },
        {
          name: "is_internal",
          property: "isInternal",
          number: 18,
          type: {
            kind: "primitive",
            primitive: "bool",
          },
        },
        {
          name: "classifications",
          property: "classifications",
          number: 19,
          type: {
            kind: "array",
            item: {
              kind: "record",
              ctor: MeetingInfo_ResolvedClassification,
            },
          },
          mutableGetter: "mutableClassifications",
        },
        {
          name: "account_id",
          property: "accountId",
          number: 20,
          type: {
            kind: "primitive",
            primitive: "int64",
          },
        },
      ],
      removedNumbers: [
        9,
      ],
    },
  ]
);
